// i18n 初始化：繁中（zh-TW，source of truth）+ 英文（en）
// - 語言偵測：localStorage(gs_lang) → navigator；偵測結果不自動寫入 localStorage（caches: false），
//   只有用戶在切換器明確選擇時才持久化（見 LanguageSwitcher）
// - zh 系瀏覽器（zh-HK/zh-CN…）一律正規化為 zh-TW；未支援語系 fallback zh-TW
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhTWCommon from './locales/zh-TW/common.json';
import zhTWHome from './locales/zh-TW/home.json';
import zhTWContent from './locales/zh-TW/content.json';
import zhTWOrder from './locales/zh-TW/order.json';
import zhTWDishes from './locales/zh-TW/dishes.json';
import zhTWMydash from './locales/zh-TW/mydash.json';
import zhTWPartner from './locales/zh-TW/partner.json';
import zhTWMerchant from './locales/zh-TW/merchant.json';
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enContent from './locales/en/content.json';
import enOrder from './locales/en/order.json';
import enDishes from './locales/en/dishes.json';
import enMydash from './locales/en/mydash.json';
import enPartner from './locales/en/partner.json';
import enMerchant from './locales/en/merchant.json';

export type AppLanguage = 'zh-TW' | 'en';

export const normalizeLanguage = (lng: string | undefined | null): AppLanguage => {
  if (!lng) return 'zh-TW';
  const l = lng.toLowerCase();
  if (l.startsWith('en')) return 'en';
  if (l.startsWith('zh')) return 'zh-TW';
  return 'zh-TW';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-TW': { common: zhTWCommon, home: zhTWHome, content: zhTWContent, order: zhTWOrder, dishes: zhTWDishes, mydash: zhTWMydash, partner: zhTWPartner, merchant: zhTWMerchant },
      en: { common: enCommon, home: enHome, content: enContent, order: enOrder, dishes: enDishes, mydash: enMydash, partner: enPartner, merchant: enMerchant },
    },
    fallbackLng: 'zh-TW',
    defaultNS: 'common',
    ns: ['common', 'home', 'content', 'order', 'dishes', 'mydash', 'partner', 'merchant'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'gs_lang',
      caches: [],
    },
    interpolation: { escapeValue: false },
  });

const syncHtmlLang = (lng: string) => {
  document.documentElement.lang = normalizeLanguage(lng) === 'en' ? 'en' : 'zh-Hant';
};

syncHtmlLang(i18n.language);

i18n.on('languageChanged', (lng) => {
  syncHtmlLang(lng);
  // navigator 偵測出的 zh-HK / en-US 等正規化為 zh-TW / en（不持久化）
  const normalized = normalizeLanguage(lng);
  if (normalized !== lng) {
    i18n.changeLanguage(normalized);
  }
});

// 啟動時立即正規化一次（處理 navigator 偵測結果）
const initial = normalizeLanguage(i18n.language);
if (initial !== i18n.language) {
  i18n.changeLanguage(initial);
}

export default i18n;
